<template>
  <div class="home">
    <!-- banner区域 -->
    <div class="banner">
      <img src="../assets/images/banner.png" alt="" />
    </div>

    <div class="body">
      <div class="sectionArea">
        <div class="sectionLeft">
          <!-- 五站一场 -->
          <section-container containWidth="860" title="五站一场">
            <template v-slot:stationWeather>
              <traffic-echarts></traffic-echarts>
            </template>
          </section-container>

          <!-- 天气摘要 -->
          <section-container containWidth="414" title="天气摘要">
            <template v-slot:weatherSummary>
              <weather-summary></weather-summary>
            </template>
          </section-container>

          <!-- 景点天气 -->
          <section-container containWidth="414" title="景点天气">
            <template v-slot:scenicSpotsWeather>
              <scenic-spots-weather></scenic-spots-weather>
            </template>
          </section-container>

          <!-- 七天精细化预报 -->
          <section-container containWidth="860" title="七天精细化预报">
            <template v-slot:sevenDaysWeather>
              <div class="sevenDaysWeather">
                <seven-days-gift :showTitle="true"></seven-days-gift>
              </div>
            </template>
          </section-container>

          <!-- 广州重要交通枢纽精细化预报 / 道路交通预报 -->
          <section-container containWidth="860">
            <template v-slot:TransportationHub>
              <div class="TransportationHub">
                <road-weather></road-weather>
              </div>
            </template>
          </section-container>

          <!-- 天气微博 -->
          <section-container containWidth="860" title="天气微博">
            <template v-slot:weatherWeibo>
              <div class="weatherWeibo">
                <weather-weibo></weather-weibo>
              </div>
            </template>
          </section-container>

          <!-- 广州微博群 -->
          <section-container containWidth="860" title="广州微博群">
            <template v-slot:weiboGroup>
              <div class="weiboGroup">
                <weibo-group></weibo-group>
              </div>
            </template>
          </section-container>
        </div>
        <div class="sectionRight">
          <!-- 短时预报 -->
          <section-container containWidth="336" title="短时预报">
            <template v-slot:shortTime>
              <short-time></short-time>
            </template>
          </section-container>

          <!-- 周边城市天气 -->
          <section-container containWidth="336" title="周边城市天气">
            <template v-slot:aroundCityWeather>
              <div class="aroundCityWeather">
                <around-city-weather></around-city-weather>
              </div>
            </template>
          </section-container>

          <!-- 空气质量 -->
          <section-container containWidth="336" title="空气质量">
            <template v-slot:airQuality>
              <div class="airQuality">
                <air-quality></air-quality>
              </div>
            </template>
          </section-container>

          <!-- 预警信号 -->
          <section-container containWidth="336" title="预警信号">
            <template v-slot:areaAlarm>
              <div class="areaAlarm">
                <alarm-signal></alarm-signal>
              </div>
            </template>
          </section-container>

          <!-- 生活指数 -->
          <section-container containWidth="336" title="生活指数">
            <template v-slot:lifePercent>
              <div class="lifePercent">
                <life-percent></life-percent>
              </div>
            </template>
          </section-container>
        </div>
      </div>
    </div>

    <my-footer></my-footer>
  </div>
</template>

<script>
import weatherSummary from '../components/HomeChild/weatherSummary.vue'
import container from '../components/HomeChild/container.vue'
import scenicSpotsWeather from '../components/HomeChild/scenicSpotsWeather.vue'
import shortTime from '../components/HomeChild/shortTime.vue'
import airQuality from '../components/HomeChild/airQuality.vue'
import weatherWeibo from '../components/HomeChild/weatherWeibo.vue'
import AlarmSignal from '../components/HomeChild/alarmSignal.vue'
import weiboGroup from '../components/HomeChild/weiboGroup.vue'
import lifePercent from '../components/HomeChild/lifePercent.vue'
import myFooter from '../components/public/footer.vue'
import aroundCityWeather from '../components/HomeChild/aroundCityWeather.vue'
import trafficEcharts from '../components/HomeChild/trafficECharts.vue'
import sevenDaysGift from '../components/HomeChild/sevenDaysGift.vue'
import roadWeather from '../components/HomeChild/roadWeather.vue'
export default {
  name: 'Home',
  created () {
  },
  methods: {

  },
  components: {
    sectionContainer: container,
    weatherSummary,
    scenicSpotsWeather,
    shortTime,
    airQuality,
    weatherWeibo,
    AlarmSignal,
    weiboGroup,
    lifePercent,
    myFooter,
    aroundCityWeather,
    trafficEcharts,
    sevenDaysGift,
    roadWeather
  }

}
</script>

<style lang="less" scoped>
.publishTime {
  color: #756c5e;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}

.publishContent {
  width: 100%;
  padding: 5px;
  font-size: 14px;
  text-indent: 1.5em;
}
.home {
  font-family: SourceHanSansCN-Bold, Verdana, Arial, Helvetica, sans-serif;
  background-image: url("../assets/images/BG.png");
  background-size: 100% 100%;
  .banner {
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }
  .body {
    width: 1230px;
    margin: 0 auto;
    .sectionArea {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 20px;
      .sectionLeft,
      .sectionRight {
        display: flex;
        flex-wrap: wrap;
        // flex-direction: column;
        justify-content: space-between;
      }

      .sectionLeft {
        width: 860px;
      }

      .sectionRight {
        width: 336px;
      }
    }
  }
}
</style>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
li {
  list-style: none;
}

a {
  text-decoration: none;
  color: #333;
}

a:hover {
  color: rgb(0, 0, 238);
}

table {
  border-spacing: 0;
}
</style>
